import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo.png';
import logoHorizontal from '../images/logo-horizontal.png';
import cart from '../images/shopping-basket.svg';
import account from '../images/account.svg';
import logout from '../images/logout-circle.svg';
import { digitalOptionCost, smallPrintCost, bigPrintCost } from '../utils/prices';
import { useSelector } from 'react-redux';
import { api } from '../utils/api';

export default function Header({ signOut, loggedIn, smallPrintCounterSum, bigPrintCounterSum, digitalOptionCounterSum, onCheckoutClick }) {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [totalSales, setTotalSales] = useState(null);

  useEffect(() => {
    let mounted = true;
    if (currentUser && currentUser.isAdmin) {
      api.getAllUsers()
        .then((users) => {
          if (!mounted) return;
          const sum = (Array.isArray(users) ? users : []).reduce((acc, u) => {
            const v = Number(u && u.hasPaid);
            return acc + (isNaN(v) ? 0 : v);
          }, 0);
          setTotalSales(Math.round(sum));
        })
        .catch((err) => {
          console.error('Failed to fetch users for total sales', err);
          if (mounted) setTotalSales(0);
        });
    } else {
      // not admin: clear totalSales to let normal calculation display
      setTotalSales(null);
    }
    return () => { mounted = false; };
  }, [currentUser]);
  return (
    loggedIn ? (
      <header className='header'>
        <Link to='/'><img src={logo} className='header__logo' alt='Logo' /></Link>
        <div className='header__logo-horizontal-container'><Link to='/'><img src={logoHorizontal} className='header__logo-horizontal' alt='Logo' /></Link></div>
        <div className='header__group'>
          <Link className='header__link' to='/account'>
            <div className='header__link-content'>
              <div className='header__icon'><img src={account} alt='account'/></div>
              <div className='header__text'>Account</div>
            </div>
          </Link>

          <Link className='header__link header__order-btn' onClick={currentUser && currentUser.isAdmin ? undefined : onCheckoutClick}>
            <div className='header__link-content'>
              <div className='header__icon'><img src={cart} alt='order'/></div>
              <div className='header__text'>
                {currentUser && currentUser.isAdmin ? (
                  <>
                    Sales: {(totalSales ?? 0).toLocaleString()} ₽
                  </>
                ) : (
                  <>
                    Order: {digitalOptionCounterSum * digitalOptionCost + smallPrintCounterSum * smallPrintCost + bigPrintCounterSum * bigPrintCost} ₽
                  </>
                )}
              </div>
            </div>
          </Link>

          <Link className='header__link' onClick={signOut} to='/sign-in'>
            <div className='header__link-content'>
              <div className='header__icon'><img src={logout} alt='logout'/></div>
              <div className='header__text'>Exit</div>
            </div>
          </Link>
        </div>
      </header>
    ) : (
      <header className='header header_noborder'></header>
    )
  );
}
